import React from 'react'

const OneManDeliveryIcon = ({ width = '1em', height = '1em', fill = '#333', ...props }) => (
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill={fill} width={width} height={height} {...props}>
    <path d='M18.813 17.25H21v-4.5h-3a.75.75 0 0 1-.712-.513L15.21 6H2.998l-.031 11.25h.97a2.751 2.751 0 0 1 5.126 0h4.624a2.751 2.751 0 0 1 5.126 0zm.142 1.5a2.75 2.75 0 0 1-5.41 0h-4.34a2.75 2.75 0 0 1-5.41 0h-1.58a.75.75 0 0 1-.75-.752L1.5 5.248a.75.75 0 0 1 .75-.748h13.5a.75.75 0 0 1 .712.513l2.079 6.237h3.209a.75.75 0 0 1 .75.75v6a.75.75 0 0 1-.75.75h-2.795zM6.5 19.5a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5zm9.75 0a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5z' />
  </svg>
)

export default OneManDeliveryIcon
